import { CWBaseModel } from 'src/core/models/cwBase.model';

export class CWCalendaccVascoModel extends CWBaseModel {

  constructor(attributes?: { [key: string]: any }, options?: { [key: string]: any }) {
    CWCalendaccVascoModel.prototype.idAttribute = "id";
    super(attributes, options);
  }
}